import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20artistic%20flat%20lay%20of%20assorted%20contemporary%20fashion%20items%20including%20white%20sneakers%20beige%20hoodie%20sunglasses%20watch%20and%20a%20leather%20bag%20arranged%20harmoniously%20on%20a%20light%20cream%20textured%20surface%20with%20soft%20natural%20window%20light%20from%20left%20side%20creating%20gentle%20shadows%20editorial%20lifestyle%20product%20photography%20with%20warm%20earthy%20tones%20minimal%20Scandinavian%20aesthetic&width=1920&height=1080&seq=kakobuy-hero-v3&orientation=landscape"
          alt="Kakobuy Spreadsheet - moda i akcesoria"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-2xl">
          <span className="inline-block px-4 py-1.5 rounded-full border border-white/30 text-white/90 text-xs md:text-sm font-medium tracking-wide mb-6">
            {t('hero_tag')}
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-7xl font-heading font-light text-white leading-tight mb-6">
            {t('hero_title_1')}
            <br />
            <span className="italic font-normal text-white/80">{t('hero_title_2')}</span>
          </h1>
          <p className="text-white/70 text-sm md:text-base leading-relaxed max-w-lg mb-8">
            {t('hero_subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-accent-500 text-white text-sm md:text-base font-medium whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
            >
              {t('btn_spreadsheet')}
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border border-white/30 text-white text-sm md:text-base font-medium whitespace-nowrap hover:bg-white/10 transition-colors cursor-pointer"
            >
              {t('btn_buy_now')}
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shopping-bag-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 right-8 z-10 hidden lg:block">
        <div className="flex items-center gap-6 text-white/50 text-xs">
          <span>Sneakers</span>
          <span className="w-8 h-px bg-white/20"></span>
          <span>Hoodies</span>
          <span className="w-8 h-px bg-white/20"></span>
          <span>Jackets</span>
          <span className="w-8 h-px bg-white/20"></span>
          <span>Accessories</span>
        </div>
      </div>
    </section>
  );
}